import React, { memo } from 'react';

import { areEqualShallow } from 'Utils/equalityChecks';

import Timesheet from '../../../Assets/timesheet.svg';

// Custom css
import classes from './timesheet.module.css';

interface Props {
  className?: string;
  fill: string;
  id?: string;
  onClick?: (e: any) => void;
  onKeyUp?: (e: any) => void;
}
const TimesheetSvg = ({ className = '', fill = '#5B476B', id, onClick, onKeyUp }: Props) => (
  <Timesheet
    id={id}
    className={`${classes.timesheetBase} ${className || ''}`}
    fill={fill}
    onClick={onClick}
    onKeyUp={onKeyUp}
  />
);

TimesheetSvg.defaultProps = {
  className: undefined,
  id: undefined,
  onClick: undefined,
  onKeyUp: undefined,
};

const TimesheetSvgMemo = memo(TimesheetSvg, areEqualShallow);
export { TimesheetSvgMemo as TimesheetSvg };
